exports = function(val) {
    return val === true || val === false;
};

module.exports = exports;
